import { render, staticRenderFns } from "./EditQuestionario.vue?vue&type=template&id=465ab948&"
import script from "./EditQuestionario.vue?vue&type=script&lang=js&"
export * from "./EditQuestionario.vue?vue&type=script&lang=js&"
import style0 from "./EditQuestionario.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports